export const subscriptionDetails = {
  orderFields: {
    subscriptionTextBtn: 'Add Product to Subscription',
    subscriptionSubtotal: 'Subscription subtotal',
    nextSubtotal: 'One time add-ons subtotal',
    nextTextBtn: 'Add Product to Next Order',
    subscriptionTitle: 'Subscription Products',
    nextTitle: 'One Time Add-Ons'
  },
  active: {
    exploreButton: 'Add & Swap Products',
    free: 'Free',
    shippingAddress: 'Shipping Address',
    subscriptionButton: 'Add & Swap Products',
    orderTotal: 'Order Total:',
    nextOrderButton: 'Add Product to Next Order',
    emtyTitle: 'One Time Add-Ons:',
    qty: 'x',
    subscriptionProductsTitle: 'Subscription Products',
    lastOrderDetails: 'Last Order Details',
    backButton: 'Back to List',
    emptyText:
      'Shop the full range of AG1 products and accessories, available exclusively to members.',
    emptyButton: 'Add Product to Next Order',
    nextOrderLabel: 'Next Order Date:',
    addOns: 'One Time Add-Ons:',
    nextShipmentTitle: 'Next Order'
  },
  reactivate: {
    headline:
      'Your subscription has been canceled and an email confirmation will be sent to {{email}}.',
    title: 'In case you miss us...',
    subTitle:
      'We’d love to have you back! Did you know about these options that make it easy to {{verb}} a shipment or get more value from your AG1 subscription?',
    agzSubTitle:
      'We’d love to have you back! You can log in and restart your subscription anytime by clicking “reactivate”.',
    reactivateOfferCard: {
      delay: {
        heading: '“I have too much.”',
        text: 'Just need a little time to catch up? Delay your next shipment of AG1.',
        btnText: 'Reactivate & Delay'
      },
      skip: {
        heading: '“I have too much.”',
        text: 'Just need a little time to catch up? Skip your next shipment of AG1.',
        btnText: 'Reactivate & Skip'
      },
      switch: {
        heading: '“I’m on a budget.”',
        textTwoPouches:
          'Switch to 2 pouches shipped every 60 days to take advantage of members-only pricing with fewer shipments (an {{symbolCurrency}}18 value).',
        textThreePouches:
          'Switch to 3 pouches shipped every 90 days to take advantage of members-only pricing and free shipping — a {{symbolCurrency}}42 value.',
        btnText: 'Reactivate & Switch'
      },
      upgrade: {
        heading: '“I don’t like the taste.”',
        text: 'With one click, switch your subscription to our upgraded formula with more probiotics, nutrients and new tropical flavor.',
        learnMoreLinkText: 'Learn more.',
        btnText: 'Reactivate & Upgrade'
      }
    }
  },
  reactivateConfirm: {
    title: 'Confirm your new plan',
    tableHead: 'You will be billed on:',
    tableSubHead: 'You unlocked an',
    tableSubHeadValue: 'value',
    tableSubHeadOn: 'on',
    subTotal: 'Subtotal',
    shipping: 'Shipping',
    free: 'FREE',
    total: 'Total',
    confirmButton: 'Confirm',
    cancelButton: 'No Thanks',
    offer: {
      subtitleThreePouches:
        'Reactivate your subscription and take advantage of members- only pricing and free shipping — a {{symbolCurrency}}42 value.',
      subtitleTwoPouches:
        'Reactivate your subscription and take advantage of members-only pricing with fewer shipments — an {{symbolCurrency}}18 value.',
      promotionText: '{{pouches}} pouches and fewer shipments'
    },
    newPlan: {
      title: 'Your new AG1 plan:',
      titleSecondary: 'Your AG1 will ship:',
      mainText: '{{pouches}} pouches shipped every {{days}} days',
      nextShipment: 'Next Shipment:'
    }
  },
  reactivateSuccess: {
    title: 'We’re glad to have you back!',
    subBtn: 'See My Subscription',
    learnMore: {
      title: 'Foundational Nutrition in a single scoop',
      text: 'Every scoop of AG1 contains the whole body health benefits you need in a simple daily habit.*',
      btnText: 'Learn More'
    },
    offer: {
      skip: 'We’ve reactivated your membership and skipped your next shipment. Here’s to owning our health, together.',
      delay:
        'We’ve reactivated your membership and delayed your next shipment. Here’s to owning our health, together.',
      default: 'We’ve reactivated your membership. Here’s to owning our health, together.'
    }
  },
  v2: {
    active: {
      nextOrderTitle: 'Next Order',
      shippingFrequency: 'Shipping Frequency',
      item: 'Every'
    },
    editFrequency: {
      day: 'Day'
    },
    orderItems: {
      subscriptionDescription: 'Subscription',
      nextOrderOnlyDescription: 'This order only',
      toBeAppliedAfterNextOrder: 'To be applied after next order'
    },
    reactivate: {
      success: 'Your subscription has been reactivated'
    },
    errors: {
      apiError: "We're experiencing a momentary technical issue. Please try again later."
    }
  },
  switched: {
    title: 'Your next order will ship {{productName}}',
    text: 'On the following order {{nextOrderDate}} your subscription will resume shipping {{productName}}.',
    singularOfPouch: 'The Pouch',
    pluralOfPouch: 'Pouches',
    singularOfTravelPacks: '1 box of Travel Packs',
    pluralOfTravelPacks: 'boxes of Travel Packs',
    omegas: 'and AG1 Omegas'
  }
};
